<!-- by 7527189 2 0 -->
<template>
    <a-row :gutter="24">
      <a-col :md="24">
        <a-card :style="cardStyle1" :bordered="false">
          <!-- 查询区域 -->
          <div class="table-page-search-wrapper">
            <!-- 搜索区域 -->
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="仓库" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="请选择仓库" v-model="queryParam.depotId">
                      <a-select-option v-for="(depot, index) in depotList" :value="depot.id" :key="index">
                        {{ depot.depotName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="批号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入批号" v-model="queryParam.batchNumber"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="关键字" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入名称/规格" v-model="queryParam.param"></a-input>
                  </a-form-item>
                </a-col>
  
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-col :md="8" :lg="6"  :sm="24">
                    <a-button type="primary" @click="searchQuery">查询</a-button>
                    <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                    <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                      {{ toggleSearchStatus ? '收起' : '展开' }}
                      <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                    </a> -->
                  </a-col>
                </span>
                <!-- <template v-if="toggleSearchStatus"> -->
                <!-- <a-col :md="8" :lg="6"  :sm="24">
                    <a-form-item label="入库单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input placeholder="请输入入库单号" v-model="queryParam.number"></a-input>
                    </a-form-item>
                  </a-col> -->
                <!-- <a-col :md="8" :lg="6"  :sm="24">
                    <a-form-item label="入库时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <JDate  v-model:value="queryParam.createTime" />
                      <a-range-picker style="width:100%" v-model="queryParam.createTime" format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onDateChange" @ok="onDateOk" />
                    </a-form-item>
                  </a-col> -->
                <!-- <a-col :md="8" :lg="6"  :sm="24">
                    <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select placeholder="请选择状态" v-model="queryParam.enabled">
                        <a-select-option value="1">启用</a-select-option>
                        <a-select-option value="0">禁用</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col> -->
                <!-- <a-col :md="8" :lg="6"  :sm="24">
                    <a-form-item label="序列号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select placeholder="有无序列号" v-model="queryParam.enableSerialNumber">
                        <a-select-option value="1">有</a-select-option>
                        <a-select-option value="0">无</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col> -->
                <!-- <a-col :md="8" :lg="6"  :sm="24">
                    <a-form-item label="批号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select placeholder="有无批号" v-model="queryParam.enableBatchNumber">
                        <a-select-option value="1">有</a-select-option>
                        <a-select-option value="0">无</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col> -->
                <!-- <a-col :md="8" :lg="6"  :sm="24">
                    <a-form-item label="扩展信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input style="width: 100%" placeholder="请输入扩展信息查询" v-model="queryParam.materialOther"></a-input>
                    </a-form-item>
                  </a-col> -->
                <!-- <a-col :md="8" :lg="6"  :sm="24">
                    <a-form-item label="基础重量" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number style="width: 100%" placeholder="请输入基础重量查询" v-model="queryParam.weight"></a-input-number>
                    </a-form-item>
                  </a-col> -->
                <!-- <a-col :md="8" :lg="6"  :sm="24">
                    <a-form-item label="保质期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number style="width: 100%" placeholder="请输入保质期查询" v-model="queryParam.expiryNum"></a-input-number>
                    </a-form-item>
                  </a-col> -->
                <!-- <a-col :md="8" :lg="6"  :sm="24">
                    <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input placeholder="请输入备注查询" v-model="queryParam.remark"></a-input>
                    </a-form-item>
                  </a-col> -->
                <!-- </template> -->
              </a-row>
            </a-form>
          </div>
          <!-- 操作按钮区域 -->
          <div class="table-operator" style="margin-top: 5px">
            <a-button v-if="btnEnableList.indexOf(1) > -1" @click="handleAdd" type="primary" icon="plus">新增</a-button>
            <a-button v-if="btnEnableList.indexOf(1) > -1" @click="handleImportXls()" type="primary"
              icon="import">导入</a-button>
            <a-button type="primary" icon="download" @click="$refs.exportConfirmDate.show(handleExportXls,'商品信息')">导出</a-button>
  <!--          <a-button type="primary" icon="download" @click="batchSetMaterialCurrentStock()">修正库存</a-button>-->
  <!--          <a-dropdown>-->
  <!--            <a-menu slot="overlay">-->
  <!--              <a-menu-item key="1" v-if="btnEnableList.indexOf(1)>-1" @click="batchDel"><a-icon type="delete" />删除</a-menu-item>-->
  <!--              <a-menu-item key="2" v-if="btnEnableList.indexOf(1)>-1" @click="batchSetStatus(true)"><a-icon type="check-square" />启用</a-menu-item>-->
  <!--              <a-menu-item key="3" v-if="btnEnableList.indexOf(1)>-1" @click="batchSetStatus(false)"><a-icon type="close-square" />禁用</a-menu-item>-->
  <!--              <a-menu-item key="4" v-if="btnEnableList.indexOf(1)>-1" @click="batchEdit()"><a-icon type="edit" />批量编辑</a-menu-item>-->
  <!--              <a-menu-item key="5" v-if="btnEnableList.indexOf(1)>-1" @click="batchSetMaterialCurrentStock()"><a-icon type="stock" />修正库存</a-menu-item>-->
  <!--            </a-menu>-->
  <!--            <a-button>-->
  <!--              批量操作 <a-icon type="down" />-->
  <!--            </a-button>-->
  <!--          </a-dropdown> -->
          </div>
          <!-- table区域-begin -->
  <!--        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, columnWidth: '2%' }"-->
          <div>
            <a-table ref="intable" size="middle" bordered rowKey="id" :columns="columns" :dataSource="dataSource"
              :pagination="ipagination"  :scroll="{ x: true }"  :loading="loading"
  
              @change="handleTableChange">
              <span slot="action" slot-scope="text, record">
  <!--              <a @click="handledetail(record)">查看</a>-->
  <!--              <a-divider v-if="btnEnableList.indexOf(1) > -1" type="vertical" />-->
  <!--              <a-popconfirm v-if="btnEnableList.indexOf(1) > -1" title="确定删除吗?" @confirm="() => handleDelete(record.id)">-->
  <!--                <a>删除</a>-->
  <!--              </a-popconfirm>-->
                <a @click="openSetMaterialCurrentStock(record)">调整库存</a>
              </span>
              <!-- <span slot="nameTitle">
                名称
                <a-tooltip title="消费者进行防伪查询时展示的该产品的名称">
                  <a-icon type="question-circle" />
                </a-tooltip>
              </span>
              <span slot="UDITitle">
                UDI名称
                <a-tooltip title="申报DI时的产品名称">
                  <a-icon type="question-circle" />
                </a-tooltip>
              </span>
              <span slot="pTitle">
                产品名称
                <a-tooltip title="企业内部进行产品区分的名称">
                  <a-icon type="question-circle" />
                </a-tooltip>
              </span> -->
              <template slot="customBarCode" slot-scope="text, record">
                {{ record.mBarCode }}
                <a-popover placement="right" trigger="click">
                  <template slot="content">
                    <img :src='getImgUrl(record.imgName)' width="500px" />
                  </template>
                  <a-icon v-if="record.imgName" style="font-size: 18px" theme="twoTone" type="file-image" />
                </a-popover>
              </template>
              <template slot="Ctotal" slot-scope="text, record">
                <div class="box">
                  <span class="text">{{ count(record.info) }}</span>
                </div>
              </template>
              <template slot="materialName" slot-scope="text, record">
                <div class="box" v-for="(it, idx) in record.info">
                  <span class="text">{{ it.materialName }}</span>
                  <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
                </div>
              </template>
              <template slot="barCode" slot-scope="text, record">
                <div class="box" v-for="(it, idx) in record.info">
                  <span class="text">{{ it.barCode }}</span>
                  <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
                </div>
              </template>
              <template slot="customnumber" slot-scope="text, record">
                <div class="box" v-for="(it, idx) in record.info">
                  <!-- <a @click="numberDetail(it.uuid)" class="text">{{it.number}}</a> -->
                  <span class="text">{{ it.number }}</span>
                  <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
                </div>
              </template>
              <template slot="customrows" slot-scope="text, record">
                <div v-for="(it, idx) in record.info">
                  <span>{{ it.quantity }}</span>
                  <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
                </div>
              </template>
              <template slot="createTime" slot-scope="text, record">
                <span>{{ timestampToTime(record.createTime) }}</span>
  
                <!-- <div v-for="(it,idx) in record.info">
                  <span>{{timestampToTime(it.createTime)}}</span>
                  <a-divider v-if="record.info.length!=1&&idx!=record.info.length-1" />
                </div> -->
              </template>
              <template slot="CquantitySpec" slot-scope="text, record">
                <div v-for="(it, idx) in record.info">
                  <span>{{ it.quantitySpec }}</span>
                  <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
                </div>
              </template>
              <!-- <template slot="CdepotName" slot-scope="text, record">
                <div v-for="(it,idx) in record.info">
                  <span>{{it.depotName}}</span>
                  <a-divider v-if="record.info.length!=1&&idx!=record.info.length-1" />
                </div>
              </template> -->
              <template slot="CcreateBy" slot-scope="text, record">
                <div v-for="(it, idx) in record.info">
                  <span>{{ it.createBy }}</span>
                  <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
                </div>
              </template>
              <template slot="standard" slot-scope="text, record">
                <div v-for="(it, idx) in record.info">
                  <span>{{ it.standard }}</span>
                  <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
                </div>
              </template>
              <!-- <template slot="packSpec" slot-scope="text, record">
                <div v-if="record.packSpec&&record.packSpec.split(',')">
                  <div v-for="it in record.packSpec.split( ','||'，')">{{ it.substring(9) ? it : ''}}</div>
                </div>
              </template> -->
              <!-- <template slot="customRenderStock" slot-scope="text, record">
                <a-tooltip :title="record.bigUnitStock">
                  {{text}}
                </a-tooltip>
              </template>  -->
            </a-table>
          </div>
          <!-- table区域-end -->
          <!-- 表单区域 -->
          <import-file-modal ref="modalImportForm" @ok="modalFormOk"></import-file-modal>
          <IndetailModel ref="IndetailModelref" @ok="modalFormOk"></IndetailModel>
          <exportConfirmDate ref="exportConfirmDate" ></exportConfirmDate>
        </a-card>
      </a-col>
      <a-modal title="设置库存" :visible="showModal" @ok="setMaterialCurrentStock" @cancel="()=>{currentRow={};changeNumber='';showModal =false}">
        <a-form layout="inline">
          <a-form-item label="当前库存：" :labelCol="labelCol" :wrapperCol="wrapperCol" style="width: 100%">
            {{currentRow.currentNumber}}
          </a-form-item>
          <a-form-item label="更新库存：" :labelCol="labelCol" :wrapperCol="wrapperCol" style="width: 100%">
            <a-input v-model="changeNumber"></a-input>
          </a-form-item>
        </a-form>
      </a-modal>
    </a-row>
  </template>
  <script>
  import IndetailModel from './modules/indetailModel'
  import ImportFileModal from '@/components/tools/ImportFileModal'
  // import BatchSetInfoModal from './modules/BatchSetInfoModal'
  import { queryMaterialCategoryTreeList } from '@/api/api'
  import { postAction, getFileAccessHttpUrl, getAction } from '@/api/manage'
  import { getMpListShort } from '@/utils/util'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JEllipsis from '@/components/jeecg/JEllipsis'
  import JDate from '@/components/jeecg/JDate'
  import Vue from 'vue'
  
  export default {
    name: 'MaterialList',
    mixins: [JeecgListMixin],
    components: {
      IndetailModel,
      ImportFileModal,
      JEllipsis,
      JDate,
    },
    data () {
      return {
        changeNumber:'',
        currentRow:{},
        showModal:false,
        categoryTree: [],
        mPropertyListShort: '',
        model: {},
        depotList: [],
        labelCol: {
          span: 5,
        },
        wrapperCol: {
          span: 18,
          offset: 1,
        },
        // 查询条件
        queryParam: {
          param: '',
          batchNumber: '',
        },
        ipagination: {
          pageSizeOptions: ['10', '20', '30', '50', '100', '200'],
        },
        // 实际表头
        columns: [],
        // 初始化设置的表头
        settingColumns: ['barCode', 'depotName', 'batchNumber', 'materialName', 'standard', 'unit', 'currentNumber','action'],
        // 默认的列
        defColumns: [
  
          { title: '产品编码', align: 'center', dataIndex: 'barCode', width: 100 },
  
          { title: '仓库', align: 'center', dataIndex: 'depotName', width: 60 },
          { title: '批次号', align: 'center', dataIndex: 'batchNumber', width: 80 },
          { title: '名称', align: 'center', dataIndex: 'materialName', width: 80 },
          { title: '规格', align: 'center', dataIndex: 'standard', width: 80 },
          { title: '单位', align: 'center', dataIndex: 'unit', width: 80 },
          // { title: '有效日期', dataIndex: 'beginTime', width: 80 },
          { title: '库存', align: 'center', dataIndex: 'currentNumber', width: 80 },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            width: 100,
            scopedSlots: { customRender: 'action' },
          },
        ],
        url: {
          list: '/serialNumber/stockList',
          delete: '/material/delete',
          deleteBatch: '/material/deleteBatch',
          importExcelUrl: '/serialNumber/exportExcelStock',
          exportXlsUrl: '/serialNumber/exportExcelStock',
          batchSetStatusUrl: '/material/batchSetStatus',
          batchSetMaterialCurrentStockUrl: '/material/batchSetMaterialCurrentStock',
        },
      }
    },
    created () {
      this.initColumnsSetting()
      this.getDepotData()
      // this.loadTreeData()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}${this.url.importExcelUrl}`
      },
    },
    methods: {
      numberDetail (uuid) {
        console.log(uuid, 'uuid')
        this.$refs.modaltree.show(uuid)
      },
      getDepotData () {
        getAction('/depot/findDepotByCurrentUser').then((res) => {
          if (res.code === 200) {
            this.depotList = res.data
          } else {
            this.$message.info(res.data)
          }
        })
      },
      count (arr) {
        let num = 0
        arr.forEach((it) => {
          num += Number(it.quantity)
        })
        return num
      },
      handledetail () {
        console.log('123')
        this.$refs.IndetailModelref.add()
      },
      onDateChange: function (value, dateString) {
        this.queryParam.beginTime = dateString[0]
        this.queryParam.endTime = dateString[1]
      },
      //加载初始化列
      initColumnsSetting () {
        let columnsStr = Vue.ls.get('intable')
        if (columnsStr && columnsStr.indexOf(',') > -1) {
          this.settingColumns = columnsStr.split(',')
        }
        this.columns = this.defColumns.filter((item) => {
          if (this.settingColumns.includes(item.dataIndex)) {
            return true
          }
          return false
        })
      },
  
      loadTreeData () {
        let that = this
        let params = {}
        params.id = ''
        queryMaterialCategoryTreeList(params).then((res) => {
          if (res) {
            that.categoryTree = []
            for (let i = 0; i < res.length; i++) {
              let temp = res[i]
              that.categoryTree.push(temp)
            }
          }
        })
      },
      setMaterialCurrentStock(){
        if(!isNaN(this.changeNumber) ){
          let that = this
          postAction('/serialNumber/modifyStockBatchNumber', {
            depotId:this.currentRow.depotId,
            batchNumber:this.currentRow.batchNumber,
            materialId:this.currentRow.materialId,
            modifyNum:parseInt(this.changeNumber),
          })
            .then((res) => {
              if (res.code === 200) {
                that.$message.info('修正库存成功!')
                that.loadData()
                that.showModal =false
              } else {
                console.log(res)
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.loading = false
            })
        }else{
          this.$message.warn('请输入正整数库存')
        }
      },
      openSetMaterialCurrentStock(row){
        this.currentRow = row
        this.changeNumber = ''
        this.showModal = true
      },
      batchSetMaterialCurrentStock () {
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning('请选择一条记录！')
        } else {
          let ids = ''
          for (let a = 0; a < this.selectedRowKeys.length; a++) {
            ids += this.selectedRowKeys[a] + ','
          }
          let that = this
          
          this.$confirm('是否操作选中数据?', '确认操作', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            that.loading = true
              postAction(that.url.batchSetMaterialCurrentStockUrl, { ids: ids })
                .then((res) => {
                  if (res.code === 200) {
                    that.$message.info('修正库存成功!')
                    that.loadData()
                    that.onClearSelected()
                  } else {
                    that.$message.warning(res.data.message)
                  }
                })
                .finally(() => {
                  that.loading = false
                })
          }).catch(() => {});
        }
      },
      batchEdit () {
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning('请选择一条记录！')
        } else {
          let ids = ''
          for (let a = 0; a < this.selectedRowKeys.length; a++) {
            ids += this.selectedRowKeys[a] + ','
          }
          this.$refs.batchSetInfoModalForm.edit(ids)
          this.$refs.batchSetInfoModalForm.title = '批量编辑'
        }
      },
      handleEdit: function (record) {
        this.$refs.modalForm.edit(record)
        this.$refs.modalForm.title = '编辑'
        this.$refs.modalForm.disableSubmit = false
        if (this.btnEnableList.indexOf(1) === -1) {
          this.$refs.modalForm.isReadOnly = true
        }
      },
      getImgUrl (imgName) {
        if (imgName && imgName.split(',')) {
          return getFileAccessHttpUrl('systemConfig/static/' + imgName.split(',')[0])
        } else {
          return ''
        }
      },
      handleImportXls () {
        let importExcelUrl = this.url.importExcelUrl
        let templateUrl = '/doc/goods_template.xls'
        let templateName = '商品Excel模板[下载]'
        this.$refs.modalImportForm.initModal(importExcelUrl, templateUrl, templateName)
        this.$refs.modalImportForm.title = '商品导入'
      },
      searchReset () {
        this.queryParam = {}
        this.loadData(1)
      },
    },
  }
  </script>
  <style scoped>
  @import '~@assets/less/common.less';
  </style>